'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgNavigationCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 14c3.284 0 6-2.709 6-6 0-3.284-2.716-6-6.007-6C4.709 2 2 4.716 2 8c0 3.291 2.716 6 6 6zm-.004-1.286a4.696 4.696 0 01-4.71-4.718 4.688 4.688 0 014.703-4.71 4.707 4.707 0 014.725 4.71 4.702 4.702 0 01-4.718 4.718zm-2.18-1.881c.116 0 .24-.051.342-.146l1.696-1.704c.059-.051.102-.08.153-.08.044 0 .088.029.146.08l1.697 1.704a.5.5 0 00.342.146c.225 0 .393-.153.393-.408a.788.788 0 00-.066-.292L8.532 5.102c-.117-.291-.299-.43-.525-.43-.24 0-.415.139-.531.43l-1.988 5.031a.788.788 0 00-.066.292c0 .255.16.408.394.408z", fill: "currentColor" }))));
}

module.exports = SvgNavigationCircle;
//# sourceMappingURL=NavigationCircle.js.map
